/* External */
import isEmptyL from "lodash/isEmpty";
import jwt_decode from "jwt-decode";

/* Actions */
import { logout } from "../state/user/actions";

/* Others */
import store from "../state/configureStore";

/* Constants */
const CHROMECAST_SAVED_DATA = "chromecastSavedData";
const IS_BANNER_SHOWN = "isBannerShown";
const DEVICE_ID = "deviceId";
const AUDIO_AND_SUBTITLES_PREFERENCES = "audioAndSubtitlesPreferences";
export const SESSION_TOKEN = "sessionToken";
export const RENEW_ENTITLEMENTS = "renewEntitlements";
export const FR_ACCESS_TOKEN = "frToken";
export const FR_ID_TOKEN = "frIdToken";
export const FR_SSO_TOKEN = "ssoToken";
export const DATA_LAYER = "DATA_LAYER";
export const USER = "user";
const KEYS_TO_WATCH = [
  IS_BANNER_SHOWN,
  DEVICE_ID,
  USER,
  AUDIO_AND_SUBTITLES_PREFERENCES,
  SESSION_TOKEN,
  RENEW_ENTITLEMENTS,
  FR_ACCESS_TOKEN,
  FR_ID_TOKEN,
  FR_SSO_TOKEN
];

export const loadState = () => {
  try {
    let isBannerShown = localStorage.getItem(IS_BANNER_SHOWN);
    const deviceId = localStorage.getItem(DEVICE_ID) || "";
    const sessionToken = localStorage.getItem(SESSION_TOKEN) || "";
    const renewEntitlementsLS = localStorage.getItem(RENEW_ENTITLEMENTS) || "";
    const frToken = localStorage.getItem(FR_ACCESS_TOKEN) || "";
    const frIdToken = localStorage.getItem(FR_ID_TOKEN) || "";
    const ssoToken = localStorage.getItem(FR_SSO_TOKEN) || "";
    const audioAndSubtitlesPreferencesLS = localStorage.getItem(AUDIO_AND_SUBTITLES_PREFERENCES) || "";
    let user = localStorage.getItem(USER) || {};
    let renewEntitlements = {},
      audioAndSubtitlesPreferences = {};
    const parsedIsBannerShow = JSON.parse(isBannerShown);
    isBannerShown = parsedIsBannerShow === null ? true : parsedIsBannerShow;

    if (renewEntitlementsLS) renewEntitlements = JSON.parse(renewEntitlementsLS);
    if (audioAndSubtitlesPreferencesLS) audioAndSubtitlesPreferences = JSON.parse(audioAndSubtitlesPreferencesLS);
    if (!isEmptyL(user)) user = JSON.parse(user);
    const { msoProvider } = user;
    if (!msoProvider && frIdToken) {
      const { msoProvider: idTokenMsoProvider } = jwt_decode(frIdToken);
      user.msoProvider = idTokenMsoProvider;
    }

    return {
      user: {
        account: user,
        deviceId,
        sessionToken,
        renewEntitlements,
        frToken,
        frIdToken,
        ssoToken
      },
      isBannerShown,
      audioAndSubtitlesPreferences
    };
  } catch (error) {
    console.error("localStorage - loadState error: ", error);
  }
};

export const saveState = (state) => {
  const {
    user: { account, deviceId, ssoToken, isLoggingOut },
    isBannerShown,
    audioAndSubtitlesPreferences
  } = state;

  if (isLoggingOut) return;

  try {
    // Serialize
    const serializedAccount = !isEmptyL(account) ? JSON.stringify(account) : null;
    const serializedAudioAndSubtitlesPreferences = !isEmptyL(audioAndSubtitlesPreferences)
      ? JSON.stringify(audioAndSubtitlesPreferences)
      : null;

    // Save
    localStorage.setItem(IS_BANNER_SHOWN, isBannerShown);
    serializedAccount && localStorage.setItem(USER, serializedAccount);
    deviceId && localStorage.setItem(DEVICE_ID, deviceId);
    serializedAudioAndSubtitlesPreferences &&
      localStorage.setItem(AUDIO_AND_SUBTITLES_PREFERENCES, serializedAudioAndSubtitlesPreferences);
    ssoToken && localStorage.setItem(FR_SSO_TOKEN, ssoToken);

    const dataLayer = getDataLayer();
    if (dataLayer && !dataLayer.user.userId) {
      // fill missing dataLayer data
      dataLayer.user.userId = account.uid;
      dataLayer.user.loginType = account.userType;
      dataLayer.user.namePackage = account.entitlements.map((entitlement) => entitlement.package.name);
      localStorage.setItem(DATA_LAYER, JSON.stringify(dataLayer));
    }
  } catch (error) {
    console.error("localStorage - saveState error: ", error);
  }
};

export const clearLocalStorage = () => {
  const isBannerShown = getIsBannerShown();
  const audioAndSubtitlesPreferences = getAudioAndSubtitlesPreferences();

  localStorage.clear();
  localStorage.setItem(IS_BANNER_SHOWN, isBannerShown);
  localStorage.setItem(AUDIO_AND_SUBTITLES_PREFERENCES, audioAndSubtitlesPreferences);
};

export const getRenewEntitlements = () => {
  const rawRenewEntitlements = localStorage.getItem(RENEW_ENTITLEMENTS);

  return rawRenewEntitlements && JSON.parse(rawRenewEntitlements);
};

export const getSessionToken = () => localStorage.getItem(SESSION_TOKEN);
export const getFrToken = () => localStorage.getItem(FR_ACCESS_TOKEN);
export const getFrIdToken = () => localStorage.getItem(FR_ID_TOKEN);
export const getSsoToken = () => localStorage.getItem(FR_SSO_TOKEN);
export const getEntitlementsList = () =>
  JSON.parse(localStorage.getItem(USER)).entitlements.map(({ package: { id = "" } = {} }) => id);
export const getIsBannerShown = () => localStorage.getItem(IS_BANNER_SHOWN);
export const getAudioAndSubtitlesPreferences = () => localStorage.getItem(AUDIO_AND_SUBTITLES_PREFERENCES);
export const setSessionToken = (sessionToken) => localStorage.getItem(SESSION_TOKEN, sessionToken);
export const getDeviceId = () => localStorage.getItem(DEVICE_ID);
export const getUser = () => JSON.parse(localStorage.getItem(USER));
export const getChromecastSavedData = () => JSON.parse(localStorage.getItem(CHROMECAST_SAVED_DATA));
export const removeChromecastSavedData = () => localStorage.removeItem(CHROMECAST_SAVED_DATA);
export const setChromecastSavedData = (data) => localStorage.setItem(CHROMECAST_SAVED_DATA, JSON.stringify(data));
const getDataLayer = () => JSON.parse(localStorage.getItem(DATA_LAYER));

window.addEventListener(
  "storage",
  (event) => {
    if (KEYS_TO_WATCH.includes(event.key) && !event.newValue) {
      const isLoggingOut = store.getState().user.isLoggingOut;
      if (!isLoggingOut) store.dispatch(logout());
    }
  },
  { passive: true }
);
